import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Box, Button, Typography } from 'shared/ui'
import { useReviewViewContext } from 'pages/reviews/context'
import { PreviewStar } from 'pages/reviews/ui/Preview/PreviewStar'
import { PreviewLogo } from 'pages/reviews/ui/Preview/PreviewLogo'
import { type ITabType } from 'pages/reviews/store/type'
import styles from './styles.module.scss'

export const PreviewAppearance = observer(() => {
  const { title, subtitle, setActiveTab, setScrollToStep } = useReviewViewContext()
  const [activeStar, setActiveStar] = useState(0)

  const handleSubmit = () => {
    const targetTab: ITabType = activeStar < 4 ? 'unhappy' : 'happy'

    setActiveTab(targetTab)
    setScrollToStep(targetTab)
  }

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'48px 16px 16px'}
    >
      <PreviewLogo />
      <Box padding={'0 24px'} display={'flex'} flexDirection={'column'}>
        <Typography ariaLabel={'reviewTitle'} className={styles.title} marginBottom={7}>
          {title || 'Title'}
        </Typography>
        <Typography
          ariaLabel={'reviewSubtitle'}
          variant={'body-rg-medium'}
          className={'textCenter'}
          marginBottom={32}
        >
          {subtitle || 'Subtitle'}
        </Typography>
      </Box>
      <div className={styles.starsWrap}>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={'12px'}>
          {Array.from({ length: 5 }, (_, index) => (
            <PreviewStar
              key={index}
              index={index}
              activeStar={activeStar}
              onClick={setActiveStar}
            />
          ))}
        </Box>
        {!!activeStar && (
          <Box paddingTop={'16px'}>
            <Button
              text='Submit'
              size='medium'
              fullWidth
              disableHover
              className={styles.submitBtn}
              onClick={handleSubmit}
            />
          </Box>
        )}
      </div>
    </Box>
  )
})
